import * as React from "react";
import Svg, { Defs, ClipPath, Path, G } from "react-native-svg";
const LogoVertical  = (props) => (
  <Svg
    width="100%"
    height="100%"
    viewBox="0 0 85.195831 56.885418"
    id="svg8"
    {...props}
  >
    <Defs id="defs2">
      <ClipPath clipPathUnits="userSpaceOnUse" id="clipPath26">
        <Path d="M 0,160.503 H 241.016 V 0 H 0 Z" id="path24" />
      </ClipPath>
    </Defs>
    <G id="layer1">
      <G
        id="g22"
        clipPath="url(#clipPath26)"
        transform="matrix(0.35277777,0,0,-0.35277777,0,56.621573)"
      >
        <G id="g28" transform="translate(241.0156,29.0982)">
          <Path
            d="m 0,0 v 22.672 c 0,5.702 -4.613,10.315 -10.314,10.315 -5.516,0 -10.259,-3.264 -12.413,-7.967 -1.066,4.56 -5.163,7.967 -10.042,7.967 -5.128,0 -9.796,-2.862 -12.139,-7.364 v 6.228 h -6.034 V 0 h 6.034 v 15.936 c 0,6.384 5.194,11.578 11.578,11.578 2.67,0 4.842,-2.172 4.842,-4.842 V 0 h 6.034 v 15.936 c 0,6.399 5.179,11.578 11.578,11.578 2.676,0 4.842,-2.166 4.842,-4.842 L -6.034,0 Z"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path30"
          />
        </G>
        <G id="g32" transform="translate(178.3506,60.9488)">
          <Path
            d="m 0,0 v -15.367 c 0,-6.384 -5.193,-11.578 -11.577,-11.578 -2.67,0 -4.842,2.172 -4.842,4.842 V 0 h -6.035 v -22.103 c 0,-5.688 4.628,-10.315 10.315,-10.315 5.128,0 9.796,2.861 12.139,7.364 v -6.802 H 6.035 V 0 Z"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path34"
          />
        </G>
        <Path
          d="m 143.583,29.098 h 6.058 v 46.068 h -6.058 z"
          style={{
            fill: "#53565A",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          id="path36"
        />
        <Path
          d="m 129.364,29.098 h 6.058 v 46.068 h -6.058 z"
          style={{
            fill: "#53565A",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          id="path38"
        />
        <G id="g40" transform="translate(116.5049,60.9488)">
          <Path
            d="m 0,0 v -15.367 c 0,-6.384 -5.194,-11.578 -11.578,-11.578 -2.67,0 -4.842,2.172 -4.842,4.842 V 0 h -6.034 v -22.103 c 0,-5.688 4.627,-10.315 10.314,-10.315 5.129,0 9.797,2.861 12.14,7.364 v -6.802 H 6.034 V 0 Z"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path42"
          />
        </G>
        <G id="g44" transform="translate(79.3916,56.7696)">
          <Path
            d="m 0,0 c 4.16,0 7.3,-1.407 9.54,-2.818 v 5.636 c -1.922,1.024 -4.931,2.497 -9.861,2.497 -9.863,0 -16.716,-7.107 -16.716,-16.778 0,-9.668 6.853,-16.778 16.716,-16.778 4.831,0 7.927,1.442 9.861,2.463 v 5.554 c -2.005,-1.2 -5.264,-2.702 -9.54,-2.702 -6.47,0 -10.951,4.741 -10.951,11.463 C -10.951,-4.737 -6.404,0 0,0"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path46"
          />
        </G>
        <G id="g48" transform="translate(44.4229,57.0904)">
          <Path
            d="M 0,0 C -5.508,0 -9.122,-4.227 -9.634,-8.837 H 8.645 C 8.709,-4.227 5.699,0 0,0 m 14.536,-9.926 v -3.137 H -9.698 v -0.064 c 0.192,-6.276 4.703,-10.247 11.427,-10.247 4.354,0 8.901,1.281 11.59,3.01 v -5.443 c -2.497,-1.409 -6.788,-2.754 -11.974,-2.754 -10.118,0 -16.97,6.853 -16.97,16.778 0,9.67 6.852,16.778 15.688,16.778 9.415,0 14.473,-7.044 14.473,-14.921"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path50"
          />
        </G>
        <G id="g52" transform="translate(11.3916,43.0015)">
          <Path
            d="m 0,0 c -6.714,1.857 -11.392,4.291 -11.392,10.054 0,5.315 5.659,9.029 13.505,9.029 4.074,0 8.073,-0.896 10.638,-1.921 V 11.783 C 10.035,13 6.263,14.024 2.867,14.024 c -4.3,0 -7.979,-1.281 -7.979,-4.162 0,-2.562 2.924,-3.779 8.055,-5.187 7.997,-2.241 11.92,-4.739 11.92,-10.118 0,-5.828 -5.583,-9.03 -13.73,-9.03 -4.904,0 -9.28,0.897 -12.298,2.114 v 5.443 c 3.696,-1.537 8.525,-2.626 12.071,-2.626 3.923,0 7.753,1.153 7.753,4.163 C 8.659,-2.625 5.584,-1.537 0,0"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path54"
          />
        </G>
        <G id="g56" transform="translate(101.9385,91.733)">
          <Path
            d="M 0,0 9.438,9.755 9.226,-3.773 c 2.215,-0.571 4.512,-0.939 6.868,-1.089 V 25.809 L -5.678,4.037 C -3.921,2.521 -2.021,1.168 0,0 m 45.91,7.238 c 2.073,2.291 3.862,4.844 5.315,7.602 l -6.201,5.889 8.605,-0.215 c 0.947,2.889 1.549,5.936 1.754,9.09 H 23.473 Z M 20.95,-4.856 c 3.155,0.208 6.201,0.812 9.091,1.762 l -0.216,8.623 5.899,-6.208 c 2.755,1.455 5.306,3.246 7.594,5.322 L 20.879,27.082 Z M 55.385,34.46 c -0.152,2.356 -0.522,4.653 -1.094,6.868 l -13.492,-0.213 9.725,9.411 c -1.167,2.021 -2.52,3.921 -4.036,5.677 L 24.746,34.46 Z"
            style={{
              fill: "#53565A",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path58"
          />
        </G>
        <G id="g60" transform="translate(84.3525,115.5381)">
          <Path
            d="M 0,0 17.07,0.198 4.901,-11.691 c 0.677,-1.054 1.406,-2.071 2.182,-3.049 L 25.513,3.69 H -0.645 C -0.491,2.44 -0.275,1.209 0,0 M 6.839,30.912 C 6.366,30.304 5.913,29.682 5.479,29.045 L 20.014,14.762 -0.318,14.933 C -0.455,14.181 -0.569,13.42 -0.66,12.653 H 25.098 Z M 55.996,39.404 44.09,27.218 44.288,44.31 c -1.209,0.274 -2.44,0.49 -3.69,0.642 V 18.775 l 18.448,18.448 c -0.979,0.776 -1.995,1.506 -3.05,2.181 M 29.355,44.621 29.525,24.274 15.239,38.812 C 14.604,38.377 13.98,37.924 13.374,37.452 L 31.635,19.19 v 25.774 c -0.768,-0.091 -1.528,-0.206 -2.28,-0.343"
            style={{
              fill: "#FFC600",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
            id="path62"
          />
        </G>
      </G>
        <G transform="translate(38.7,48.4) scale(0.277) translate(-244.3,-18.3)">
          <G transform="matrix(1.3333333,0,0,-1.3333333,0,51.199867)">
            <G transform="translate(184.8958,18.6263)">
              <Path d="M 0,0 H 2.542 C 3.363,0 4.018,0.213 4.503,0.64 4.988,1.065 5.231,1.635 5.231,2.349 5.231,3.126 5,3.722 4.537,4.136 4.074,4.551 3.407,4.761 2.533,4.767 H 0 Z M 2.947,-1.353 H 0 V -6.429 H -1.663 V 6.119 H 2.49 C 3.904,6.119 4.991,5.798 5.752,5.154 6.514,4.511 6.895,3.574 6.895,2.345 6.895,1.563 6.684,0.882 6.261,0.302 5.839,-0.278 5.251,-0.712 4.498,-0.999 L 7.446,-6.325 V -6.429 H 5.671 Z" style={{ fill: "#53565A", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }} />
            </G>
            <G transform="translate(203.7523,12.1976)">
              <Path d="M 0,0 H -1.664 V 5.8 H -7.989 V 0 h -1.656 v 12.548 h 1.656 V 7.153 h 6.325 v 5.395 H 0 Z" style={{ fill: "#53565A", fillOpacity: 1, fillRule: "nonzero", stroke: "none" }} />
            </G>
          </G>
        </G>
    </G>
  </Svg>
);
export default LogoVertical;
